
export const VERSION = '5.4.30'; // Update this manually on each release

